<template>
  <div class="filter-categories" v-if="filters.offering.length">
    <accordion title="Offering"       :items="filters.offering"   @changed="updateOfferingFilter"></accordion>
    <accordion title="Categories"     :items="filters.categories" @changed="updateCategoriesFilter"></accordion>
    <accordion title="Items"          :items="filters.items"      @changed="updateItemsFilter"></accordion>
    <accordion title="Min Resolution" :items="filters.resolutions" @changed="updateResolution" ></accordion>
  </div>
</template>

<script>
import Accordion from "./FilterCategoriesAccordion";
import { updateOfferingFilter, updateCategoriesFilter, updateItemsFilter, updateResolution } from "./FilterActions";

export default {
  components: {
    Accordion
  },
  vuex: {
    getters: {
      filters: state => state.filters
    },
    actions: { updateOfferingFilter, updateCategoriesFilter, updateItemsFilter, updateResolution }
  },
  route: {
    data () {
      this.getFilters();
    }
  }
};
</script>
<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .filter-categories{
    width: 300px;
    padding: 30px;
    background: $green_light;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// FilterCategories.vue?0263af9a